import React from 'react';
import theme from '../../../theme';
import { IGenericIconProps } from './types';

const MembersIcon: React.FC<IGenericIconProps> = ({
    width = 20,
    height = 20,
    strokeWidth = '1.5',
    strokeColor = theme.colors.beyondGrey,
    fill = 'none'
}) => (
    <svg width={width} height={height} viewBox="0 0 20 20" fill={fill}>
        <path
            d="M8.80273 2.50488C10.8952 2.61132 12.5596 4.34199 12.5596 6.46094L12.5547 6.66504C12.4783 8.16947 11.5619 9.45229 10.2656 10.0547C13.3042 10.3295 15.6855 12.883 15.6855 15.9932C15.6852 17.4868 14.4742 18.6982 12.9805 18.6982H4.21582C2.72209 18.6982 1.51113 17.4868 1.51074 15.9932C1.51074 12.883 3.89199 10.3285 6.93066 10.0537C5.63473 9.45113 4.71895 8.16926 4.64258 6.66504L4.6377 6.46094C4.6377 4.27339 6.41109 2.5 8.59863 2.5L8.80273 2.50488ZM7.47461 11.5293C5.00946 11.5293 3.01074 13.528 3.01074 15.9932C3.01113 16.6584 3.55051 17.1982 4.21582 17.1982H12.9805C13.6458 17.1982 14.1852 16.6584 14.1855 15.9932C14.1855 13.528 12.1868 11.5293 9.72168 11.5293H7.47461ZM8.59863 4C7.23951 4 6.1377 5.10182 6.1377 6.46094C6.13771 7.82004 7.23952 8.92188 8.59863 8.92188C9.95753 8.92163 11.0596 7.81989 11.0596 6.46094C11.0596 5.10197 9.95754 4.00025 8.59863 4Z"
            fill={strokeColor}
        />
        <path
            d="M18.0865 15.2921V14.0372C18.0865 11.8075 16.279 10 14.0493 10V10H13.333"
            stroke={strokeColor}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
        />
        <path
            d="M13.333 10.0003C14.9085 10.0003 16.375 8.59515 16.375 7.01966C16.375 5.44418 15.0978 4.16699 13.5223 4.16699"
            stroke={strokeColor}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
        />
    </svg>
);

export default MembersIcon;
